import type React from 'react';

export interface SidebarProps {
  children: React.ReactNode;
}

export const Sidebar = ({ children }: SidebarProps) => {
  return (
    <div className="h-full border-r border-ds-natural-150 bg-white">
      {children}
    </div>
  );
};
